import { lazy } from 'react';

export const HomePage = lazy(() =>
  import('../modules/Home/views/HomePage').then((module) => ({
    default: module.HomePage,
  })),
);

export const AdminPartnerListPage = lazy(() =>
  import('../modules/PartnerPortal/views/AdminPartnerListPage').then(
    (module) => ({
      default: module.AdminPartnerListPage,
    }),
  ),
);

export const AdminSellersPage = lazy(() =>
  import('../modules/PartnerPortal/views/AdminSellersPage').then((module) => ({
    default: module.AdminSellersPage,
  })),
);

export const AdminContractsPage = lazy(() =>
  import('../modules/PartnerPortal/views/AdminContractsPage').then(
    (module) => ({
      default: module.AdminContractsPage,
    }),
  ),
);

export const AdminWithdrawalsPage = lazy(() =>
  import('../modules/PartnerPortal/views/AdminWithdrawalsPage').then(
    (module) => ({
      default: module.AdminWithdrawalsPage,
    }),
  ),
);

export const AdminPartnerPortalLayout = lazy(() =>
  import('../modules/PartnerPortal/views/AdminPartnerPortalLayout').then(
    (module) => ({
      default: module.AdminPartnerPortalLayout,
    }),
  ),
);

export const PartnerPortalLayout = lazy(() =>
  import('../modules/PartnerPortal/views/PartnerPortalLayout').then(
    (module) => ({
      default: module.PartnerPortalLayout,
    }),
  ),
);

export const PartnerCommissionsShell = lazy(() =>
  import('../modules/PartnerPortal/views/PartnerCommissionsShell').then(
    (module) => ({
      default: module.PartnerCommissionsShell,
    }),
  ),
);

export const PartnerCommissionOverviewPage = lazy(() =>
  import('../modules/PartnerPortal/views/PartnerCommissionOverviewPage').then(
    (module) => ({
      default: module.PartnerCommissionOverviewPage,
    }),
  ),
);

export const PartnerResiduesPage = lazy(() =>
  import('../modules/PartnerPortal/views/PartnerResiduesPage').then(
    (module) => ({
      default: module.PartnerResiduesPage,
    }),
  ),
);

export const PartnerProfilePage = lazy(() =>
  import('../modules/PartnerPortal/views/PartnerProfilePage').then(
    (module) => ({
      default: module.PartnerProfilePage,
    }),
  ),
);

export const PartnerInvoicesListPage = lazy(() =>
  import('../modules/PartnerPortal/views/PartnerInvoicesListPage').then(
    (module) => ({
      default: module.PartnerInvoicesListPage,
    }),
  ),
);

export const PartnerClientDetailPage = lazy(() =>
  import('../modules/PartnerPortal/views/PartnerClientDetailPage').then(
    (module) => ({
      default: module.PartnerClientDetailPage,
    }),
  ),
);

export const PartnerClientDetailLegacyRedirect = lazy(() =>
  import('../modules/PartnerPortal/views/PartnerClientDetailLegacyRedirect').then(
    (module) => ({
      default: module.PartnerClientDetailLegacyRedirect,
    }),
  ),
);

export const AdminPartnerClientsPage = lazy(() =>
  import('../modules/PartnerPortal/views/AdminPartnerClientsPage').then(
    (module) => ({
      default: module.AdminPartnerClientsPage,
    }),
  ),
);

export const AdminPartnerExportPage = lazy(() =>
  import('../modules/PartnerPortal/views/AdminPartnerExportPage').then(
    (module) => ({
      default: module.AdminPartnerExportPage,
    }),
  ),
);

export const AdminPartnerBulkImportPage = lazy(() =>
  import('../modules/PartnerPortal/views/AdminPartnerBulkImportPage').then(
    (module) => ({
      default: module.AdminPartnerBulkImportPage,
    }),
  ),
);

export const AdminPartnerClientDataImportPage = lazy(() =>
  import('../modules/PartnerPortal/views/AdminPartnerClientDataImportPage').then(
    (module) => ({
      default: module.AdminPartnerClientDataImportPage,
    }),
  ),
);
